import React from "react";

import { CONTAINER_CLASS } from "../../shared/styleConstants";

import { useMainLayoutStyles } from "./MainLayout.styles";

export const MainLayout: React.FC<React.PropsWithChildren<any>> = (props) => {
  const mainLayoutStyles = useMainLayoutStyles();
  return (
    <div className={CONTAINER_CLASS} style={mainLayoutStyles.container}>
      {props.children}
    </div>
  );
};
